<h3 class="text-center rounded text-white">Admission Count Report {{selectedYear}}</h3>

<div class="d-flex justify-content-between row">
  <div class="d-flex justify-content-end">
    <!-- Uncomment if needed -->
    <!-- <mat-checkbox [(ngModel)]="showInactiveCentres">Show All Centres</mat-checkbox> -->
  </div>

  <div class="d-flex gap-1">
    <mat-form-field appearance="outline">
      <mat-label>Select Financial Year</mat-label>
      <mat-select [(value)]="selectedYear" (selectionChange)="onYearChange($event.value)">
        <mat-option *ngFor="let year of financialYears" [value]="year">
          {{ year }}
        </mat-option>
      </mat-select>
    </mat-form-field>

<!--    <button mat-mini-fab color="accent">-->
<!--      <mat-icon>search</mat-icon>-->
<!--    </button>-->
<!--    <button mat-mini-fab color="accent">-->
<!--      <mat-icon>clear</mat-icon>-->
<!--    </button>-->
  </div>
</div>

<div class="ngxTableHeader">
  <ul class="header-buttons-left ms-0 mb-0">
    <li class="dropdown">
      <h2>Admission Yearly Reports</h2>
    </li>
  </ul>
  <ul class="header-buttons mr-2">
    <li>
<!--      <div class="export-button m-l-10" matTooltip="XLSX" >-->
<!--&lt;!&ndash;        <img src="assets/images/icons/xlsx.png" alt="Export XLSX" (click)="exportAsXLSX()" />&ndash;&gt;-->
<!--      </div>-->
    </li>
  </ul>
</div>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate">
  Please wait, data is loading...
</mat-progress-bar>

<table *ngIf="dataSource" mat-table [dataSource]="dataSource" class="mat-elevation-z8 table table-striped table-bordered" id="excel-table">
  <ng-container matColumnDef="centreName">
    <th mat-header-cell *matHeaderCellDef>Centre Name</th>
    <td mat-cell *matCellDef="let element">{{element.centreName}}</td>

  </ng-container>

  <ng-container matColumnDef="new_admission">
    <th mat-header-cell *matHeaderCellDef>New Admission</th>
    <td mat-cell *matCellDef="let element">{{element.new_admission}}</td>
  </ng-container>

  <ng-container matColumnDef="discharge">
    <th mat-header-cell *matHeaderCellDef>Discharge</th>
    <td mat-cell *matCellDef="let element">{{element.discharge}}</td>
  </ng-container>

  <ng-container matColumnDef="follow_up_admission">
    <th mat-header-cell *matHeaderCellDef>Follow Up Admission</th>
    <td mat-cell *matCellDef="let element">{{element.follow_up_admission}}</td>
  </ng-container>

  <ng-container matColumnDef="follow_up_discharge">
    <th mat-header-cell *matHeaderCellDef>Follow Up Discharge</th>
    <td mat-cell *matCellDef="let element">{{element.follow_up_discharge}}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" colspan="4">No data available for the selected financial year</td>
  </tr>
</table>
